import { React, useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useGetEpbGenerationEciReportMutation, useGetStatesStatusForceWiseQuery } from "../../../services/reportsServices";
import ReactSelect from "../../../ui/reactSelect/index"
import { useDispatch } from "react-redux";
import {
  ALERT_TYPE_ERROR,
} from "../../../constants/constants";
import { createAlert } from "../../../features/alert/alerts";
import { Validators } from "../../../library/utilities/Validator";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import MultiSelectCheckBox from "../../../ui/multiSelectCheckbox/MultiSelectCheckBox"
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";
const selectConstituencyType = [
  { value: "", label: "Select Constituency" },
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];
const tableHeader = [];
const columns = [
  {
    Header: "State Name",
    accessor: "col1",
  },
  {
    Header: "AC/PC No. and Name",
    accessor: "col2",
  },
  {
    Header: "e-PB Transmission Status",
    accessor: "col3",
  },
];
columns.map((item) => {
  tableHeader.push(item.Header)
})

const EpbGenerationEciReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "e-Postal Ballot Generation Report"
  const SheetName = "Generation Report"
  const [selected,setSelected] =useState([])
  const [data, setData] = useState({
    constituencyType: "",
    selectState: [],
  });
  const [skip, setSkip] = useState(true);
  const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery();

  const [getReports] = useGetEpbGenerationEciReportMutation()

  const stateList = [];
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);

  const [Error, setError] = useState({});

  getElectionAnnouncedState?.payload?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    });
  });
  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setSkip(true);
  };
  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  const renderTableData = () => {
    let error = {};
    if (selected === "" || selected.length === 0) {
      error["selectState"] = "This Field is required"

    }
    if (!data.constituencyType || data.constituencyType === "" || data.constituencyType.length == 0) {
      error["constituencyType"] = "This Field is required"

    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
    let statesCodesArray = []
    selected?.map((item) => {
      statesCodesArray.push(item.value)
    })

    let payload = {
      "stateCd": statesCodesArray,
      "constType": data.constituencyType
    }
    getReports(payload)
      .unwrap()
      .then((res) => {
        let tData = []
        res?.payload?.map((item) => {
          tData.push({
            "col1": item.stateName,
            "col2": `${item.acPcNo}-${item.acPcName}`,
            "col3": item.epbGenerationStatus,
          });
        });
        setTableData(tData)
        setTotalNoOfRecords(res?.payload?.length)
      }).catch((error) => {
        if (error?.data?.message === "No record found") {

          setTableData([])
        }
      })

  };

  return (
    <LeftMenu>
      <div className="container box shadow ">
        <div className="row">
          <div className="col-md-12">
            <RunnerUpHeaderNew title={reportName} 
            onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData)}
            onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData)} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <MultiSelectCheckBox
              options={stateList}
              name="selectState"
              value={selected}
              onChange={setSelected}
              labelledBy="Select"
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("selectState", val)}
              Error={Error}
            ></MultiSelectCheckBox>
            </div>
          <SelectField
            labelClass=""
            inputClass="col-md-2 pr-1"
            options={selectConstituencyType}
            value={data.constituencyType}
            name="constituencyType"
            handleChange={(val) => handleChange("constituencyType", val)}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              }
            ]}

            getError={(val) => getError("constituencyType", val)}
            Error={Error}
          ></SelectField>
          <div className="col-md-2">
            <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={renderTableData}>
              VIEW
              <span className="pl-2">
                <i class="fa fa-eye">
                </i>
              </span>
            </button>
          </div>
        </div>
        <div style={{ marginTop: "-40px" }}>
          <Table
            placeholder="Search"
            globalsearch={true}
            emptyMessage="No Record Found"
            selectall={true}
            columns={columns}
            data={tableData?.length === 0 ? [] : tableData}
            size={5}
            tableClassNameCheck="contenttable-eroll"
            pagination
            records
            gotopage
            rows
            numberrows={totalNoOfRecords}
          />
        </div>
      </div>
    </LeftMenu>
  );
};

export default EpbGenerationEciReport;
